import { render, staticRenderFns } from "./IcoYoutubeLogo.vue?vue&type=template&id=7f2a166a"
import script from "./IcoYoutubeLogo.vue?vue&type=script&lang=js"
export * from "./IcoYoutubeLogo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports